module.exports = __webpack_public_path__ + "media/images/icon__breadcrumbs-arrow-left--rb-raven-gray@3x-0b3b7f6709e4cfa9b078abb23ac62426.png";